module.exports = __webpack_public_path__ + "static/img/404.e4ae6e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/404.png
// module id = xmkN
// module chunks = 0